import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(supabaseUrl, supabaseKey);

// Funcții helper pentru operațiuni cu baza de date

// Petitii
export const getPetitions = async () => {
  const { data, error } = await supabase
    .from('petitions')
    .select(`
      *,
      signatures (count)
    `)
    .eq('is_active', true)
    .eq('approved', true)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
};

// Toate petițiile pentru admin (inclusiv neaprobate)
export const getAllPetitions = async () => {
  const { data, error } = await supabase
    .from('petitions')
    .select(`
      *,
      signatures (count)
    `)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
};

// Petițiile în așteptarea aprobării
export const getPendingPetitions = async () => {
  const { data, error } = await supabase
    .from('petitions')
    .select(`
      *,
      signatures (count)
    `)
    .eq('approved', false)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
};

export const getPetitionById = async (id) => {
  const { data, error } = await supabase
    .from('petitions')
    .select(`
      *,
      signatures (count)
    `)
    .eq('id', id)
    .single();
  
  if (error) throw error;
  return data;
};

export const createPetition = async (petitionData) => {
  const { data, error } = await supabase
    .from('petitions')
    .insert([petitionData])
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

// Creează petiție de către utilizator public
export const submitPetition = async (petitionData) => {
  const { data, error } = await supabase
    .from('petitions')
    .insert([{
      title: petitionData.title,
      description: petitionData.description,
      content: petitionData.content,
      category: petitionData.category,
      target_signatures: petitionData.target_signatures,
      submitted_by_name: petitionData.submitted_by_name,
      submitted_by_email: petitionData.submitted_by_email,
      approved: false,
      is_active: true
    }])
    .select()
    .single();
  
  if (error) {
    console.error('Supabase error:', error);
    throw error;
  }
  return data;
};

// Aprobă petiție
export const approvePetition = async (id) => {
  const { data, error } = await supabase
    .from('petitions')
    .update({ approved: true })
    .eq('id', id)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

// Respinge petiție
export const rejectPetition = async (id) => {
  const { error } = await supabase
    .from('petitions')
    .delete()
    .eq('id', id);
  
  if (error) throw error;
};

export const updatePetition = async (id, updates) => {
  const { data, error } = await supabase
    .from('petitions')
    .update(updates)
    .eq('id', id)
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const deletePetition = async (id) => {
  const { error } = await supabase
    .from('petitions')
    .delete()
    .eq('id', id);
  
  if (error) throw error;
};

// Semnături
export const signPetition = async (signatureData) => {
  const { data, error } = await supabase
    .from('signatures')
    .insert([signatureData])
    .select()
    .single();
  
  if (error) throw error;
  return data;
};

export const getPetitionSignatures = async (petitionId) => {
  const { data, error } = await supabase
    .from('signatures')
    .select('*')
    .eq('petition_id', petitionId)
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
};

export const checkIfUserSigned = async (petitionId, email) => {
  const { data, error } = await supabase
    .from('signatures')
    .select('id')
    .eq('petition_id', petitionId)
    .eq('email', email)
    .single();
  
  // Nu aruncăm eroare dacă nu găsește, doar returnăm null
  return data;
};

// Statistici email pentru admin
export const getEmailStatistics = async () => {
  const { data, error } = await supabase
    .rpc('get_email_statistics');
  
  if (error) throw error;
  return data;
};

// Export emails pentru admin
export const getEmailsForExport = async () => {
  const { data, error } = await supabase
    .from('email_export')
    .select('*')
    .order('signed_at', { ascending: false });
  
  if (error) throw error;
  return data;
};

// Toate emailurile unice
export const getUniqueEmails = async () => {
  const { data, error } = await supabase
    .from('signatures')
    .select('email')
    .eq('is_anonymous', false)
    .order('email');
  
  if (error) throw error;
  
  // Returnează doar emailurile unice
  const uniqueEmails = [...new Set(data.map(item => item.email))];
  return uniqueEmails;
};
